import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "currentColor",
  stroke: "none"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", { d: "M8 11.2097C7.50116 11.2097 7.09677 11.6141 7.09677 12.1129C7.09677 12.6117 7.50116 13.0161 8 13.0161C8.49884 13.0161 8.90323 12.6117 8.90323 12.1129C8.90323 11.6141 8.49884 11.2097 8 11.2097ZM8.24742 10.4355H7.73129C7.51752 10.4355 7.34419 10.2622 7.34419 10.0484V10.0361C7.34419 7.76697 9.84226 7.98387 9.84226 6.57132C9.84226 5.92564 9.26932 5.27419 7.98935 5.27419C7.04923 5.27419 6.56145 5.58545 6.07932 6.19974C5.95326 6.36039 5.72274 6.39313 5.55519 6.27639L5.13152 5.98123C4.95006 5.85481 4.91023 5.60152 5.04619 5.42713C5.7309 4.54884 6.54329 3.98387 7.98935 3.98387C9.6771 3.98387 11.1326 4.94358 11.1326 6.57132C11.1326 8.74597 8.63452 8.63097 8.63452 10.0361V10.0484C8.63452 10.2622 8.46119 10.4355 8.24742 10.4355ZM8 1.53226C11.8265 1.53226 14.9677 4.63145 14.9677 8.5C14.9677 12.3481 11.8513 15.4677 8 15.4677C4.15342 15.4677 1.03226 12.3528 1.03226 8.5C1.03226 4.65474 4.14845 1.53226 8 1.53226ZM8 0.5C3.58203 0.5 0 4.08332 0 8.5C0 12.9193 3.58203 16.5 8 16.5C12.418 16.5 16 12.9193 16 8.5C16 4.08332 12.418 0.5 8 0.5Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const UikitQuestionMarkIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  UikitQuestionMarkIcon as default
};
//# sourceMappingURL=QuestionMarkIcon.vue.es.js.map
